import { generatePath } from "@routes/utils.ts";
import { approve } from "@api/candidates/approve/path";
import { disapprove } from "@api/candidates/disapprove/path";

const pathBase = `/candidates/`;

export const candidates = {
  getAll: () => generatePath(pathBase, null),
  approve,
  disapprove,
};
